import {effects} from 'redux-saga';
import appSagas from './app/appSaga';
import languageSwitcherSagas from './languageSwitcher/languageSwitcherSaga';
import sagaAuthSagas from './sagaAuth/sagaAuthSaga';
import sagaProjectSagas from './sagaProject/sagaProjectSaga';
import sagaPropertySagas from './sagaProperty/sagaPropertySaga';
import sagaOfferSagas from './sagaOffer/sagaOfferSaga';
import sagaContractSagas from './sagaContract/sagaContractSaga';
import sagaUserSagas from './sagaUser/sagaUserSaga';
import sagaEnquirySagas from './sagaEnquiry/sagaEnquirySaga';
import sagaSettingSagas from './sagaSetting/sagaSettingSaga';
import sagaReportSagas from './sagaReport/sagaReportSaga';
import sagaDeedSagas from './sagaDeed/sagaDeedSaga';
import sagaLoanSagas from './sagaLoan/sagaLoanSaga';
import sagaContactSagas from './sagaContact/sagaContactSaga';
import sagaLeads from './sagaLead/sagaLeadSaga';
import sagaEmailSagas from './sagaEmail/sagaEmailSaga';

export default function* rootSaga() {
    yield effects.all([
        sagaAuthSagas(),
        appSagas(),
        sagaProjectSagas(),
        languageSwitcherSagas(),
        sagaPropertySagas(),
        sagaOfferSagas(),
        sagaContractSagas(),
        sagaUserSagas(),
        sagaEnquirySagas(),
        sagaSettingSagas(),
        sagaReportSagas(),
        sagaDeedSagas(),
        sagaLoanSagas(),
        sagaContactSagas(),
        sagaLeads(),
        sagaEmailSagas(),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagas.ts